module.exports = __webpack_public_path__ + "img/opensea.c9c2e532.svg";